<template>
	<v-menu offset-y eager>
		<template v-slot:activator="{ on, attrs }">
			<v-btn icon small v-bind="attrs" v-on="on" color="primary">
				<v-icon>mdi-dots-vertical</v-icon>
			</v-btn>
		</template>
		<v-list dense>
			<v-list-item link @click="$emit('edit', item)">
				<v-list-item-title class="size9">Modifica</v-list-item-title>
			</v-list-item>
			<v-list-item link :disabled="item.status === 'generating'" @click="$emit('generate', item)">
				<v-list-item-title class="size9">{{ pubblicato ? 'Rigenera' : 'Genera' }}</v-list-item-title>
			</v-list-item>
			<template v-for="out in item.outputs || []">
				<v-divider :key="out.lang + '-d'"></v-divider>
				<v-subheader :key="out.lang + '-h'" class="fl-menu-head">{{ etichetta(out.lang) }}</v-subheader>
				<v-list-item :key="out.lang + '-v'" link :href="out.viewer_url" target="_blank">
					<v-list-item-title class="size9">Apri sfogliatore</v-list-item-title>
				</v-list-item>
				<v-list-item :key="out.lang + '-p'" link :href="out.pdf_url" target="_blank">
					<v-list-item-title class="size9">Scarica PDF</v-list-item-title>
				</v-list-item>
				<v-list-item :key="out.lang + '-c'" link @click="$emit('copy', out.viewer_url)">
					<v-list-item-title class="size9">Copia link</v-list-item-title>
				</v-list-item>
			</template>
			<v-divider></v-divider>
			<v-list-item link @click="$emit('delete', item)">
				<v-list-item-title class="size9">Elimina</v-list-item-title>
			</v-list-item>
		</v-list>
	</v-menu>
</template>

<script>
import { LINGUE } from './flyerUtils';

// menu a tre puntini di una riga: le voci di sfogliatore e PDF ci sono una volta per lingua
export default {
	name: 'FlyerRowMenu',
	props: {
		item: { type: Object, required: true },
	},
	computed: {
		pubblicato() {
			return (this.item.outputs || []).length > 0;
		},
	},
	methods: {
		etichetta(lang) {
			return LINGUE[lang] || String(lang).toUpperCase();
		},
	},
};
</script>

<style scoped>
.fl-menu-head {
	height: 28px;
	font-size: 11px;
	text-transform: uppercase;
	letter-spacing: 0.4px;
}
</style>
